// -----------------------------------------------------------------------------
// 業務運用状態 オペレーション
// -----------------------------------------------------------------------------
import {updateStatus} from './actions';

/**
 * 業務運用状態更新
 *
 * @param {Object} status 業務運用状態
 *      - {String} current 現在の運用状態
 *      - {String} coming 近々の運用状態
 * @return {Function} ディスパッチ関数
 */
export const doUpdateStatus = (status) => {
  return async (dispatch) => {
    dispatch(updateStatus(status));
  };
};

// -----------------------------------------------------------------------------
// エクスポート
// -----------------------------------------------------------------------------
export default {
  doUpdateStatus,   // 業務運用状態更新
};
